import { render, staticRenderFns } from "./ResumeClinic.vue?vue&type=template&id=517bd92a"
import script from "./ResumeClinic.vue?vue&type=script&lang=js"
export * from "./ResumeClinic.vue?vue&type=script&lang=js"
import style0 from "./ResumeClinic.vue?vue&type=style&index=0&id=517bd92a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports